<script>
import { IS_PREVIEW_ENVIRONMENT } from '../../../config/builderConfig.js';
import website from '../../../config/seo-website';
import ogImageSrc from '../../../images/open-graph.jpg';
import featuredImageSrc from '../../../images/open-graph.jpg';
import OpenGraph from './OpenGraph.svelte';
import SchemaOrg from './SchemaOrg.svelte';

const {
    author,
    siteDescription,
    contactEmail,
    facebookPage,
    ogLanguage,
    siteLanguage,
    siteTitle,
    siteUrl,
    linkedinProfile,
} = website;

const defaultAlt = 'Skywire logo on black background';

/**
 * @typedef {Object} Props
 * @property {boolean} [article]
 * @property {{ name: string; slug: string }[]} [breadcrumbs]
 * @property {{ url: string; faviconWidth: number; faviconHeight: number } | null} [entityMeta]
 * @property {Date | string} lastUpdated
 * @property {Date | string} datePublished
 * @property {String} metaDescription
 * @property {String} slug
 * @property {String} title
 * @property {any} [featuredImage]
 * @property {any} [ogImage]
 * @property {any} [squareImage]
 */

/** @type {Props} */
let {
    article = false,
    breadcrumbs = [],
    entityMeta = null,
    lastUpdated,
    datePublished,
    metaDescription,
    slug,
    title,
    featuredImage = {
        url: featuredImageSrc,
        alt: defaultAlt,
        width: 672,
        height: 448,
        caption: 'Home page',
    },
    ogImage = {
        url: ogImageSrc,
        alt: defaultAlt,
    },
    squareImage,
} = $props();
let url = $derived(`${siteUrl}${slug}`);
let pageTitle = $derived(title);

let openGraphProps = $derived({
    image: ogImage,
    squareImage,
    metaDescription,
    ogLanguage,
    pageTitle,
    siteTitle,
    url,
});
let schemaOrgProps = $derived({
    article,
    author,
    siteDescription,
    contactEmail,
    breadcrumbs,
    datePublished,
    lastUpdated,
    entityMeta,
    featuredImage,
    metaDescription,
    siteLanguage,
    siteTitle,
    siteUrl,
    title,
    url,
    facebookPage,
    linkedinProfile,
});
</script>

<svelte:head>
	<title>{pageTitle}</title>
	<meta name="description" content={metaDescription} />
	<link rel="canonical" href={url} />
	{#if IS_PREVIEW_ENVIRONMENT}
		<!-- Preview environment: prevent indexing -->
		<meta name="robots" content="noindex, nofollow" />
	{:else}
		<!-- Production environment: allow indexing -->
		<meta
			name="robots"
			content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
		/>
	{/if}
</svelte:head>
<OpenGraph {...openGraphProps} />
<SchemaOrg {...schemaOrgProps} />
